import httpClientBoards from '../api/httpClientBoards';

export const getAllBoards = async () => {
  const response = await httpClientBoards.get('/api/cms/BoardsManagement/GetAll');
  return response.data;
};

export const getBoardById = async (id) => {
  const response = await httpClientBoards.get(`/api/cms/BoardsManagement/GetById/${id}`);
  return response.data;
};

export const createBoard = async ({ title, members = [], isActive = true }) => {
  const response = await httpClientBoards.post('/api/cms/BoardsManagement/Create', {
    title,
    members,
    isActive,
  });
  return response.data;
};

export const updateBoard = async ({ id, title, members = [], isActive = true }) => {
  const response = await httpClientBoards.put('/api/cms/BoardsManagement/Update', {
    id,
    title,
    members,
    isActive,
  });
  return response.data;
};

export const deleteBoard = async (id) => {
  const response = await httpClientBoards.delete(`/api/cms/BoardsManagement/Delete/${id}`);
  return response.data;
};

export const reorderBoards = async ({ boardIdsInOrder }) => {
  const response = await httpClientBoards.post('/api/cms/BoardsManagement/Reorder', {
    boardIdsInOrder,
  });
  return response.data;
};

export default {
  getAllBoards,
  getBoardById,
  createBoard,
  updateBoard,
  deleteBoard,
  reorderBoards,
};


